module.exports = __webpack_public_path__ + "static/assets/63c953eda875c71912d22f5f4429e957.svg";